import Button from 'components/shared/Button/Button';

import { useDocumentZoom } from '../lib/documentZoomContext';

/**
 * Fit-to-width / actual-size switch for a `DocumentPages` document. Renders
 * nothing until the document is actually scaled down, so it stays out of the
 * way on screens wide enough to show the page at full size.
 */
const DocumentZoomToggle = ({ size = 'small', className, zoom: zoomProp }) => {
  const contextZoom = useDocumentZoom();
  const zoom = zoomProp || contextZoom;

  if (!zoom?.canZoom) return null;

  return (
    <Button
      size={size}
      variant="link"
      color="neutral"
      shade={700}
      iconShade={700}
      iconColor="neutral"
      iconSize={16}
      className={className}
      icon={zoom.isActualSize ? 'minimize-mono' : 'maximize-mono'}
      text={zoom.isActualSize ? 'Fit width' : 'Actual size'}
      onClick={zoom.toggleActualSize}
    />
  );
};

export default DocumentZoomToggle;
